export const quoteSlider2023Gql = /* GraphQL */`... on landingPageContent2023_quoteSlider_BlockType {
  typeHandle
  pageTitle
  displayInHeaderQuicklinks
  id
  slides2 {
    ... on slides2_BlockType {
      enableQuote
      quote
      quoteAuthor
      descriptor
      workplace
      authorImage {
        ... on images_Asset {
          id
          aspectRatio11 {
            srcWebp
            srcset
          }
        }
      }
      button {
        url
        target
        customText
        ariaLabel
      }
    }
  }
  theme
  backgroundOverlayOpacity
  backgroundImage {
    ... on images_Asset {
      lpImageTextUncropped {
        srcset
        srcWebp
      }
    }
  }
}`;
